import { Component, HostListener } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMars, faVenus, faCheck, faClose, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { UserDetailsService } from '../services/user-details.service';
import { RouterLink } from '@angular/router';
import { ServicesService } from '../my-profile/services.service';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-friends-tab',
  standalone: true,
  imports: [CommonModule, MatTabsModule, FontAwesomeModule, RouterLink],
  templateUrl: './friends-tab.component.html',
  styleUrl: './friends-tab.component.css'
})
export class FriendsTabComponent {

  page: any = 1;
  limit: any = 10;
  totalPages: any = 1;
  activeTab: any = 'Friends';
  constructor(private apiservices: ApiServicesService, private snackbarService: SnackbarService, private userdetails: UserDetailsService, private taskservices: ServicesService) { }
  friends: any = [];
  famale = faMars;
  fafemale = faVenus;
  faCheck = faCheck;
  faCancel = faClose;
  fatrash = faTrash
  requestPending: any[] = [];
  userData: any;
  userId: any;
  fav_friends: any[] = [];
  isLoading: boolean = false;
  showErrorMessage: boolean = false;
  is_myProfile: boolean = false;
  friends_res = true;
  fav_friends_res = true;
  selectedTabIndex = 0;
  total_friends:any;
  private subscription!: Subscription;
  private userDetailsSubscription: Subscription | null = null;

  ngOnInit() {
    // this.getFriendList(this.page, this.limit);
    this.selectedTabIndex=0;
    this.userDetailsSubscription = this.userdetails.userdetails$.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        if (userData && userData.user) {
          this.userId = this.userData.user._id;
          this.is_myProfile = this.apiservices.checkProfile(this.userData.user.username);
          this.getFriendList(this.page, this.limit);
        }
      } else {
        this.userData = '';
        this.userId = '';
      }
    });
    this.subscription = this.taskservices.changeFriendsTab$.subscribe((data) => {
      if(data==1){
        
        // this.taskservices.changefriTabrevert();
        this.getPendingRequest(1,10);
        // console.log(data,'aadadad');
        this.selectedTabIndex=2;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.userDetailsSubscription) {
      this.userDetailsSubscription.unsubscribe();
    }
  }

  getFriendList(page: any, limit: any) {
    if (this.userId) {
      this.friends_res = true;
      this.apiservices.getFriendList(this.userId, page, limit).subscribe({
        next: (friends: any) => {
          if (page == 1) {
            this.friends = friends.friends || [];
          } else {
            this.friends = [...this.friends, ...(friends.friends || [])];
          }
          this.totalPages = friends.pagination?.totalPages || 1;
          this.page = parseInt(friends.pagination?.currentPage) || 1;
          this.friends_res = false;
          this.isLoading = false;
          this.total_friends=friends?.pagination?.totalFriends;
        },
        error: (err) => {
          this.friends_res = false;
          this.isLoading = false;
          if (err.error.message == "Friend list is private.") {
            this.showErrorMessage = true;
          }
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    }
  }


  onTabChange(event: MatTabChangeEvent) {
      this.selectedTabIndex = event.index;
    if (event.tab.textLabel === 'Friend Requests') {
      this.activeTab = 'Friend Requests';
      this.getPendingRequest(1, this.limit);
    }
    if (event.tab.textLabel.includes('Friends')) {
      this.getFriendList(1, this.limit);
      this.activeTab = 'Friends';
    }
    if (event.tab.textLabel === 'My Favorites') {
      this.activeTab = 'My Favorites';
      this.getFavusers(1, this.limit);
    }
  }

  getFavusers(page: any, limit: any) {
    this.fav_friends_res = true;
    this.isLoading = true;
    this.apiservices.getFavusers(this.userId, page, limit).subscribe({
      next: (friends: any) => {
        if (page == 1) {
          this.fav_friends = friends.data || [];
        } else {
          this.fav_friends = [...this.fav_friends, ...(friends.data || [])];
        }
        this.totalPages = friends.pagination?.totalPages || 1;
        this.page = friends.pagination?.currentPage || 1;
        this.isLoading = false;
        this.fav_friends_res = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.fav_friends_res = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  cacelRequest(userid: any) {
    this.apiservices.rejectFriendrequest(userid).subscribe({
      next: (requests: any) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: requests.message,
            className: 'success',
          }
        );
        this.getPendingRequest(1, this.limit);
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  acceptRequest(userid: any) {
    this.apiservices.acceptFriendrequest(userid).subscribe({
      next: (requests: any) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: requests.message,
            className: 'success',
          }
        );
        this.total_friends=requests.acceptedFriends;
        this.getPendingRequest(1, this.limit);
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  deleteFav(userid: any) {
    this.apiservices.removeFavuser(userid).subscribe({
      next: (requests: any) => {
        this.getFavusers(1, this.limit);
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: requests.message,
            className: 'success',
          }
        );
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  getPendingRequest(page: any, limit: any) {
    this.isLoading = true;
    this.apiservices.getPendingRequest(page, limit).subscribe({
      next: (requests: any) => {
        if (page == 1) {
          this.requestPending = requests.data || [];
        } else {
          this.requestPending = [...this.requestPending, ...(requests.data || [])];
        }
        this.totalPages = requests.pagination?.totalPages || 1;
        this.page = requests.pagination?.currentPage || 1;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  @HostListener('window:scroll', ["$event"])
  onScroll(): void {
    if (
      this.page < this.totalPages &&
      !this.isLoading
    ) {
      this.page++;
      if (this.activeTab == 'Friends') {
        this.getFriendList(this.page, this.limit);
      } else if (this.activeTab == 'My Favorites') {
        this.getFavusers(this.page, this.limit);
      } else if (this.activeTab == 'Friend Requests') {
        this.getPendingRequest(this.page, this.limit);
      }
    }
  }

}
